import { render, staticRenderFns } from "./ShipmentSummaryParent.vue?vue&type=template&id=4161efb2&"
import script from "./ShipmentSummaryParent.vue?vue&type=script&lang=js&"
export * from "./ShipmentSummaryParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports